export default __webpack_public_path__ + "static/media/bonus-ico.be32cd00.svg";